import Facebook from './Facbook';
import Instagram from './Instagram';
import Pinterest from './Pinterest';
import Collapse from './Collapse';
import Tiktok from './Tiktok';
import X from './X';
import Youtube from './Youtube';
import { IGeneralSettings } from '../../../../models/IGeneralSettings';
import Whatsapp from './Whatsapp';
import Linkedin from './Linkedin';


export enum SocialIcon {
  x = 'x',
  facebook = 'facebook',
  youtube = 'youtube',
  instagram = 'instagram',
  tiktok = 'tiktok',
  whatsapp = 'whatsapp',
  linkedin = 'linkedin'
}

// Others = 0,
//  Instagram = 1,
//  Facebook = 2,
//  Twitter = 3,
//  Youtube = 4,
//  Tiktok = 5,
//  Linkedin = 6,
//  Whatsapp = 7


export let socialIcons: { [type in SocialIcon]?: { Component: any, href: string; type: SocialIcon; } } = {
  [SocialIcon.x]: {
    Component: X,
    type: SocialIcon.x,
    href: ''
  },
  [SocialIcon.facebook]: {
    Component: Facebook,
    type: SocialIcon.facebook,
    href: ''
  },
  // [SocialIcon.pinterest]: {
  //   Component: Pinterest,
  //   type: SocialIcon.pinterest,
  //   href: ''
  // },
  [SocialIcon.instagram]: {
    Component: Instagram,
    type: SocialIcon.instagram,
    href: '',
  },
  [SocialIcon.tiktok]: {
    Component: Tiktok,
    type: SocialIcon.tiktok,
    href: '',
  },
  [SocialIcon.youtube]: {
    Component: Youtube,
    type: SocialIcon.youtube,
    href: '',
  },
  [SocialIcon.whatsapp]: {
    Component: Whatsapp,
    type: SocialIcon.whatsapp,
    href: '',
  },
  [SocialIcon.linkedin]: {
    Component: Linkedin,
    type: SocialIcon.linkedin,
    href: '',
  },
}



export const socialsTypeMap: { [type in SocialIcon]?: number } = {
  [SocialIcon.instagram]: 1,
  [SocialIcon.facebook]: 2,
  [SocialIcon.x]: 3,
  [SocialIcon.youtube]: 4,
  [SocialIcon.tiktok]: 5,
  [SocialIcon.whatsapp]: 7,
  [SocialIcon.linkedin]: 6,
}


export const initializeSocialIcons = (data: IGeneralSettings['socials']) => {

  socialIcons = {
    ...socialIcons,
    ...Object.entries(socialsTypeMap).reduce((result, [key, val]) => {
      const href = data.find(x => x.type === Number(val))?.url || '';
      return {
        ...result,
        [key]: {
          ...socialIcons[key],
          href
        }
      }
    }, {})
  }
}